
        import * as module0 from './controllers/contact_form_controller.js';import * as module1 from './controllers/gallery_lightbox_controller.js';import * as module2 from './controllers/navbar_controller.js';import * as module3 from './controllers/property_filter_controller.js';import * as module4 from './controllers/team_member_modal_controller.js'
        const modules = {
            "./controllers/contact_form_controller.js": module0,
            "./controllers/gallery_lightbox_controller.js": module1,
            "./controllers/navbar_controller.js": module2,
            "./controllers/property_filter_controller.js": module3,
            "./controllers/team_member_modal_controller.js": module4,
        };
        export default modules;
      